import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getGalleryIdForApi } from '../api';

/**
 * Old bookmarks: `/dashboard/*` → `/g/{storedOrDevId}/dashboard/*`
 */
export function LegacyDashboardRedirect() {
  const location = useLocation();
  const galleryId = getGalleryIdForApi();
  if (!galleryId) {
    return <Navigate to="/" replace />;
  }
  const suffix = location.pathname.replace(/^\/dashboard/, '') || '';
  const path = `/g/${galleryId}/dashboard${suffix}`;
  const search = location.search || '';
  return <Navigate to={`${path}${search}`} replace />;
}
